import { Box, Flex, Spacer, Text } from "@chakra-ui/react";
import { Link } from "wouter";

import { ApiBulkExport, BulkExportType } from "@nens/ldo/api-v1";

import { getBulkExportUrl } from "../../../features/bulk-exports/routes";
import { ExportStatus } from "../export-status/export-status";

export function ExportItem({
  bulkExport,
  exportType,
}: {
  bulkExport: ApiBulkExport;
  exportType: BulkExportType;
}) {
  const exportUrl = getBulkExportUrl(exportType, bulkExport.id);

  const errors = (bulkExport?.errors ?? []).map((error) => error.msg);

  return (
    <Flex borderBottom="1px solid #e2e8f0" justifyContent="space-between" alignItems="center">
      <Flex p="12px" flexGrow={1} justifyContent="flex-start" gap={4}>
        <Box w="200px">
          <Link to={exportUrl}>{bulkExport.name}</Link>
        </Box>
        <Spacer />
        <Box w="200px">
          <Text
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            title={bulkExport.created_by.name}
          >
            {bulkExport.created_by.name}
          </Text>
        </Box>
        <Box w="100px">
          <ExportStatus status={bulkExport.status} />
        </Box>
        <Box w="200px">
          <Text>{errors.length === 0 ? "" : errors}</Text>
        </Box>
        <Box w="120px">{bulkExport.created_at.toLocaleDateString()}</Box>
      </Flex>
    </Flex>
  );
}
